import React, { SVGAttributes } from 'react'
// taken from here: https://github.com/danilowoz/react-content-loader/blob/master/src/web/Svg.tsx
// https://www.npmjs.com/package/react-content-loader
// supported a lot of unnecessary options, lighter - 800b

interface IContentLoaderProps extends SVGAttributes<SVGElement> {
    animate?: boolean
    backgroundColor?: string
    backgroundOpacity?: number
    baseUrl?: string
    foregroundColor?: string
    foregroundOpacity?: number
    gradientRatio?: number
    rtl?: boolean
    speed?: number
    title?: string
    uniqueKey?: string
    beforeMask?: JSX.Element
}

const uid = (): string => Math.random().toString(36).substring(6)

/**
 *
 */
const SVG = ({
    animate = true,
    backgroundColor = 'rgba(217, 216, 216, 0.5)',
    backgroundOpacity = 1,
    baseUrl = '',
    children,
    foregroundColor = '#eee',
    foregroundOpacity = 1,
    gradientRatio = 2,
    uniqueKey,
    rtl = false,
    speed = 1.2,
    style = {},
    title = 'Loading...',
    beforeMask = null,
    ...props
}: IContentLoaderProps): JSX.Element => {
    const fixedId = uniqueKey || uid()
    const idClip = `${fixedId}-diff`
    const idGradient = `${fixedId}-animated-diff`
    const idAria = `${fixedId}-aria`

    const rtlStyle = rtl ? { transform: 'scaleX(-1)' } : null
    const dur = `${speed}s`

    const from = `${gradientRatio * -1} 0`
    const to = `${gradientRatio} 0`

    return (
        <svg
            aria-labelledby={idAria}
            role="img"
            style={{ ...style, ...rtlStyle }}
            {...props}
        >
            {title ? <title id={idAria}>{title}</title> : null}
            {beforeMask && React.isValidElement(beforeMask) ? beforeMask : null}
            <rect
                role="presentation"
                x="0"
                y="0"
                width="100%"
                height="100%"
                clipPath={`url(${baseUrl}#${idClip})`}
                style={{ fill: `url(${baseUrl}#${idGradient})` }}
            />

            <defs>
                <clipPath id={idClip}>{children}</clipPath>

                <linearGradient
                    id={idGradient}
                    gradientTransform={`translate(${from})`}
                >
                    <stop
                        offset="0%"
                        stopColor={backgroundColor}
                        stopOpacity={backgroundOpacity}
                    />

                    <stop
                        offset="50%"
                        stopColor={foregroundColor}
                        stopOpacity={foregroundOpacity}
                    />

                    <stop
                        offset="100%"
                        stopColor={backgroundColor}
                        stopOpacity={backgroundOpacity}
                    />

                    {animate && (
                        <animateTransform
                            attributeName="gradientTransform"
                            type="translate"
                            values={`${from}; 0 0; ${to}`}
                            dur={dur}
                            repeatCount="indefinite"
                        />
                    )}
                </linearGradient>
            </defs>
        </svg>
    )
}

/**
 *
 */
export type ContentLoaderType = IContentLoaderProps

export default SVG
